import script from "./MySwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySwitch.vue?vue&type=script&setup=true&lang=ts"

import "./MySwitch.vue?vue&type=style&index=0&id=66b755f1&lang=scss"

const __exports__ = script;

export default __exports__